import React from 'react';
import { UnderConstruction } from '@core/pages';
import { navItems } from '../navigation';

const Reports: React.FC = () => {
  return <UnderConstruction navItems={navItems} path="/reports" />;
};

export default Reports;
